import ReactDOMServer from "react-dom/server";
import { PluiePopupContainer } from "./popupTableHelper";
import React from "react";
import { HttpArcgis } from "../../http";
import { app_placeholder } from "../../../env.placeholders";

export const getPovInfo = async (feature) => {
    const layerDef = "Code in ('" + feature.graphic.attributes.Code + "')";
    let idPov = feature.graphic.attributes.IdPov;

    // get POV
    try {
        const formBody: string[] = [];
        formBody.push('where=' + layerDef);
        formBody.push('outFields=IdPov');
        formBody.push('orderByFields=Distance');
        formBody.push('resultRecordCount=1');
        formBody.push('returnGeometry=false');
        formBody.push('f=json');
        const formBodyToSend = formBody.join('&');

        const responseSections = await HttpArcgis.post(
        app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/56/query',
        JSON.stringify(formBodyToSend),
        );
        if (
            responseSections.status === 200 &&
            responseSections.data.features !== undefined
        ) {
            const datas = responseSections.data.features[0].attributes.IdPov;
            idPov = datas;
        } else {
            idPov = undefined;
            console.log('Aucune données !');
        }
    } catch (error) {
        idPov = undefined;
        console.log('Failed to get idPov !', error);
    }
    return idPov;
}

// show 2 types of popup for Pluie module
export const getInfoPluie = async (feature) => {
  let attributes,
    idPov,
    content = document.createElement('div');
  attributes = feature.graphic.attributes;

  idPov = await getPovInfo(feature);

  const mode = attributes['Volume'] !== undefined ? 'pluie' : 'pluvio';

  let tableElements;
  if (mode === 'pluie') {
    tableElements = {
      'Volume déversé':
        attributes['Volume'] !== undefined && attributes['Volume'] !== 'Null'
          ? parseFloat(attributes['Volume'].replace(',', '.'))
              .toFixed(1)
              .concat(' m³')
          : 'NR',
      'Cumul pluie':
        attributes['Mesure'] !== undefined && attributes['Volume'] !== 'Null'
          ? parseFloat(attributes['Mesure'].replace(',', '.'))
              .toFixed(1)
              .concat(' mm')
          : 'NR',
      Pluviomètre: idPov !== undefined && idPov !== 'Null' ? idPov : 'NR',
    };
  } else {
    tableElements = {
      Type:
        attributes['Type'] !== undefined && attributes['Type'] !== 'Null'
          ? attributes['Type']
          : 'POV',
    };
  }

  const title = mode === 'pluie' ? attributes.Description : attributes.IdPov;
  content.innerHTML = ReactDOMServer.renderToString(
    <PluiePopupContainer
      title={title}
      tableElements={tableElements}
    />
  );
  return content;
}